import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-kpi-card',
  template: `
    <div class="card card-kpi border-0 shadow-sm h-100">
      <div class="card-body p-3">
        <div class="d-flex justify-content-between align-items-start">
          <div class="flex-grow-1">
            <h6 class="text-muted text-uppercase font-weight-bold mb-2 small-label">{{ title }}</h6>
            
            <div *ngIf="!isLoading; else loadingSkeleton">
              <h3 class="mb-0 font-weight-bold" [ngClass]="colorClass">
                {{ isCurrency ? (value | currency:'MXN':'$':'1.2-2') : value }}
              </h3>
            </div>
          </div>
          
          <div class="icon-box" [ngClass]="colorClass + '-bg'">
            <i [class]="icon"></i>
          </div>
        </div>
      </div>
    </div>

    <ng-template #loadingSkeleton>
      <div class="skeleton-line"></div>
    </ng-template>
  `,
  styles: [`
    .card-kpi { transition: transform 0.2s; border-radius: 12px; }
    .card-kpi:hover { transform: translateY(-3px); }
    
    .small-label { font-size: 0.75rem; letter-spacing: 0.5px; opacity: 0.8; }
    
    .icon-box { 
      padding: 12px; border-radius: 10px; background: rgba(0,0,0,0.03); 
      display: flex; align-items: center; justify-content: center;
    }
    
    .skeleton-line { 
      height: 24px; width: 80%; background: #eee; 
      border-radius: 4px; animation: pulse 1.5s infinite; 
    }
    
    @keyframes pulse { 
      0% { opacity: 0.6; } 50% { opacity: 1; } 100% { opacity: 0.6; } 
    }
  `]
})
export class KpiCardComponent {
  @Input() title: string = '';
  @Input() value: number | string = 0;
  @Input() icon: string = 'fa-chart-line';
  @Input() colorClass: string = 'text-primary';
  @Input() isCurrency: boolean = true;
  @Input() isLoading: boolean = false;
}


// WEBPACK FOOTER //
// ./src/app/dashboard/kpi-card.component.ts